/**
 * AI field injection types.
 */

export const FIELD_TYPES = {
  TEXT: "text",
  TEXTAREA: "textarea",
  EDITOR: "editor",
};
